import { NOTARIOS_ESPAÑA_URL, ROUTES } from '@/constants';

export const sidebarItems = [
	{ label: 'Encuentra tu notario', to: ROUTES.INFORMACION_BUSCADOR_NOTARIOS },
	{ label: 'Academia de Opositores', to: ROUTES.INFORMACION_ACADEMIA_OPOSITORES },
	{
		label: 'Corporación Notarial',
		children: [
			{ label: 'Notarios en España', to: NOTARIOS_ESPAÑA_URL },
			{ label: 'Organismos Internacionales', to: ROUTES.INFORMACION_ORGANISMOS_INTERNACIONALES },
		],
	},
	{ label: 'Encuentra tu escritura', to: ROUTES.INFORMACION_ENCUENTRA_ESCRITURA },
	{ label: 'Nuevas actuaciones Notariales', to: ROUTES.INFORMACION_NUEVAS_ACTUACIONES_NOTARIALES },
	{ label: 'Enlaces de interés', to: ROUTES.INFORMACION_ENLACES_INTERES },
];
